import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';

import {eventMomentFactory} from '../../../../data/misc/eventMomentFactory';
import {connectI18n} from '../../../connects';
import Scrollable from '../../../elements/Scrollable';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import SandboxedContent from '../../../SandboxedContent/SandboxedContent';
import Screen from '../../Screen';
import EventDateAndTime from '../common/EventDateAndTime/EventDateAndTime';
import EventHeaderImage from '../common/EventHeaderImage/EventHeaderImage';
import EventLocation from '../common/EventLocation/EventLocation';
import JoinEvent from '../common/JoinEvent/JoinEvent';

class Other extends React.Component {
    render() {
        let {community, event, i18n} = this.props,
            header = (
                <div>
                    <TopBarEvent event={community}>{event.name}</TopBarEvent>
                </div>
            ),
            start = eventMomentFactory(event, event.start_utc),
            footer = (
                <div className="content">
                    <JoinEvent eventId={event.id} i18n={i18n} />
                </div>
            );

        return (
            <Screen header={header} footer={footer}>
                <Scrollable className="graybg">
                    <EventHeaderImage event={event} />
                    <br />
                    <div className="whitebg">
                        <EventDateAndTime event={event} />
                        <EventLocation event={event} />
                    </div>
                    <hr />
                    <SandboxedContent content={event.signup_html} fitHeightToContents="fitHeightToContents" />
                    <br />
                </Scrollable>
            </Screen>
        );
    }
}

export default compose(
    connect((state, props) => {
        let community = state.events[props.communityId].event,
            event = community.subevents.find(event => event.id == props.eventId);
        return {
            community,
            event,
        };
    }),
    connectI18n
)(Other);
